import { CHANGE_BG } from '../actionTypes.js';

const initialState = {
  background: 'bliss'
}

export default function changeBackground(state = initialState, action) {
  switch (action.type) {
    case CHANGE_BG: {
      return {
        ...state,
        background: action.payload
      };
    }
    default:
      return state;
  }
}